/**
 * @file HomePage.js
 * @author Jonas Matulis, Simon Tenedero
 * @created 2024-XX-XX
 * @lastModified 2025-07-07
 * @description file containing the HomePage component.
 */

import { useUser } from "../context/UserContext";

/**
 * HomePage component serves as the landing page for the application. Prompts users to log in to watch livestreams.
 *
 * @returns {JSX.Element} The rendered HomePage component
 */
const HomePage = () => {
  const { user } = useUser();

  return (
    <div className="flex flex-col justify-start min-h-screen xl:pt-20 desktop:pt-10 pl-10">
      {user ? (
        <h1 className="my-auto text-5xl md:text-7xl font-bold">
          welcome {user.username.toLowerCase()},
          <br />
          to the <span className="text-primary">
            livestreaming
          </span> prototype. <span />
        </h1>
      ) : (
        <h1 className="my-auto text-5xl md:text-7xl font-bold">
          welcome to the <br />
          <span className="text-primary">livestreaming</span> prototype. <br />
          <span /> login to get started.
        </h1>
      )}
    </div>
  );
};

export default HomePage;
